var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "phone",
    class: {
      'mb': _vm.wayType === 'm-phone'
    }
  }, [_c('phone-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'input',
      expression: "regType === 'input'"
    }],
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "inputPhone": _vm.inputPhoneHandle
    }
  }), _vm._v(" "), _c('phone-login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'login',
      expression: "regType === 'login'"
    }],
    attrs: {
      "wayType": _vm.wayType,
      "name": _vm.phone,
      "itc": _vm.itc,
      "country": _vm.country
    },
    on: {
      "showForget": _vm.showForgetHandle,
      "success": _vm.successHandle
    }
  }), _vm._v(" "), _c('phone-reg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'reg',
      expression: "regType === 'reg'"
    }],
    attrs: {
      "wayType": _vm.wayType,
      "name": _vm.phone,
      "itc": _vm.itc,
      "country": _vm.country
    },
    on: {
      "success": _vm.successHandle,
      "inputPhone": _vm.inputPhoneHandle
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };